export default `.p-card.p-card-full-height {
  height: 100%
}
.p-card.p-card-full-height > .p-card-body {
  height: 100%;
  padding: 0;
}
.p-card.p-card-full-height > .p-card-body > .p-card-content {
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
`;
